import React from "react";
import { ArrowUpRight } from "lucide-react";

const services = [
  {
    num: "01",
    title: "Bútor újrakárpitozás",
    desc: "Teljes bútor kárpitozás kanapékra, fotelekre, székekre — új szövet, új belső, garanciával. Prémium bútorszövetekkel, hosszú távra tervezve.",
  },
  {
    num: "02",
    title: "Egyedi elképzelések megvalósítása",
    desc: "Éttermi, kávézói és otthoni terekbe egyedi méretű ülőpadok és bútorok kárpitozása — az ügyfél elképzelése alapján, méretre szabva.",
  },
  {
    num: "03",
    title: "Kerti bútorok párnázata",
    desc: "Kerti bútorok egyedi párnázatának készítése prémium, UV-álló kültéri anyagokból, amelyek hosszú távon is megőrzik minőségüket.",
  },
  {
    num: "04",
    title: "Falvédő és egyedi darabok",
    desc: "Egyedi méretű falvédő és ütközésvédő közösségi terekbe, éttermekbe, sportlétesítményekbe. Tartós, könnyen tisztítható felülettel.",
  },
  {
    num: "05",
    title: "Székek, kanapék felújítása",
    desc: "Klasszikus és modern ülőbútorok komplett felújítása: szivacscsere, rugózat ellenőrzése, szövetválasztás személyes tanácsadással.",
  },
  {
    num: "06",
    title: "Kisebb javítások, szövetcsere",
    desc: "Szakadások, kopott részek, elhasznált szövetek cseréje — gyors megoldás, hogy a bútor még éveket szolgáljon.",
  },
];

export default function Services() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="szolgaltatasok"
      data-testid="services-section"
      className="velvet-cream py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="md:col-span-6">
            <div className="overline mb-6 flex items-center">
              <span className="gold-rule" />
              Szolgáltatások
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-[#0A1228]">
              Amit
              <span className="italic text-[#1E47A8]"> kínálunk.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-base md:text-lg text-[#4A5468] leading-relaxed font-light">
              A legkisebb javítástól a teljes újrakárpitozásig, egyedi
              elképzelések megvalósításától a kültéri párnázatig — minden munkát
              ugyanazzal a figyelemmel és garanciával végzünk.
            </p>
          </div>
        </div>

        <div className="border-t border-[#0A1228]/15">
          {services.map((s) => (
            <button
              key={s.num}
              onClick={() => scrollTo("ajanlat")}
              data-testid={`service-${s.num}`}
              className="group w-full grid md:grid-cols-12 gap-6 md:gap-10 py-9 md:py-11 border-b border-[#0A1228]/15 text-left hover:bg-[#ECE7DE]/60 transition-colors px-2 md:px-4"
            >
              <div className="md:col-span-1 font-serif-display text-2xl md:text-3xl text-[#B8935A] tracking-tight">
                {s.num}
              </div>
              <div className="md:col-span-4">
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#0A1228] leading-tight group-hover:text-[#1E47A8] transition-colors">
                  {s.title}
                </h3>
              </div>
              <div className="md:col-span-6 text-[#4A5468] text-base leading-relaxed font-light">
                {s.desc}
              </div>
              <div className="md:col-span-1 flex md:justify-end items-start">
                <ArrowUpRight
                  size={24}
                  className="text-[#1E47A8] transition-transform group-hover:translate-x-1.5 group-hover:-translate-y-1.5"
                />
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
